import { createContext, useContext, useEffect, useState } from 'react';

import { MOBILE_BREAKPOINT } from '#/utils/constants';

export const AppContext = createContext();

export const useAppContext = () => useContext(AppContext);

export const AppContextProvider = ({ children }) => {
  const [isMobileMode, setIsMobileMode] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobileMode(window.innerWidth < MOBILE_BREAKPOINT);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const contextValue = {
    isMobileMode,
  };

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
};
